export default function () {
  return {
    scaneddata: ''
  }
}
